'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  wrapInScriptTags: function wrapInScriptTags(scriptBody) {
    if (!scriptBody) {
      return '';
    }

    return '\n<script>\n' + scriptBody + '\n</script>';
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-on-rails/node_package/lib/RenderUtils.js
 ** module id = 703
 ** module chunks = 0
 **/